import React from "react";
import nzlvgaBanner from "../assets/images/nzlvga_banner3.jpeg";
import './VideoPage.css';
import PracticeSection from '../component/PracticeSection';


function IndexVideo2Page() {
  return (
    <div className="container_12">
      <div className="grid_12">
        <div className="grid_12 alpha">
          <div className="box-3">
            <div className="gradient_1">
              <h2>日常训练</h2>
            </div>
            <div className="box-3_pad_3 p_text_body_indent p_text_lineheight">
              <p className="p_text_header">《第一把火》记新西兰气排球协会总会（NZLVGA）春节后首练</p>
              <p className="p_text_subheader p_text_header_white">2023年2月11日</p>
<p className="p_text_body p_text_body_ml">NZLVGA管理团队重组后的第一次训练来之不易，近期的水灾使得训练计划一推再推。
今天80多位气排球爱好者和后援支持者终于可以相约来一树山高中训练啦！是你们成就了首练
感谢大家的支持！为了你们——我们会做得更好！
</p>
              <iframe
className="video_w_xs video_h_xs video_w_sm video_h_sm video_w_md video_h_md video_w_lg video_h_lg video_w_xl video_h_xl"
                src="https://www.youtube.com/embed/6egG56H5i34?si=he191Lhuy9iocfed"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
              <br />
              <br />
              <br />


<PracticeSection
title="新西兰气排快讯一树山气排球培训进行中"
date="2023年2月18日"
description=""
embedUri="OaI-qRICFIY?si=RV9Uof8LlQ26noz5"
/>

<PracticeSection
title="《普及气排·从基础技能训练开始》"
date="2023年2月25日"
description="新西兰气排球协会总会周六在一树山高中的训练！"
embedUri="vZsb66Z5HWg?si=X_RpGIsrK6zxsy1K"
/>

<PracticeSection
title="《普及·训练·技能·全面发展——为新西兰第三届星光杯气排球锦标赛积蓄能量》"
date="2023年3月4日"
description="记新西兰气排球协会总会（NZLVGA）于一树山高中的训练集锦"
embedUri="Yku_1mlIG9o?si=yStQ1XB3hHMwpJsc"
/>

<PracticeSection
title="《队员的笑容·前行的动力》"
date="2023年3月11日"
description="新西兰气排球协会总会（NZLVGA）一日训练。
上上周是新西兰报组队来学习；
上周是和平之友联谊会前来观摩；
欢迎感兴趣的团队组队来体验气排球运动！欢迎气排球爱好者积极参与！
训练时间:周六4-6.25pm 地点:One Tree Hill College Gym"
embedUri="nfILWy3b4pQ?si=2hxFdUTnX-1fvSuf"
/>

<PracticeSection
title="《感恩有你》新西兰妇联会和气排球协会总会团队建设拓展训练日"
date="2023年3月12日"
description="“感恩有你”主题团建日由新西兰华人妇女联合基金会、新西兰气排球协会总会联合主办
* 感恩在第二届新西兰星光杯气排球锦标赛上，用爱心义务奉献的义工、裁判和参赛队员们！
* 通过多种团队建设游戏为大家带来丰富多彩、快乐开心的一天；妇联会理事成员和气排队员们之间相互的合作、共建快乐团队。
感谢组织者精心策划和摄制"
embedUri="6DBTNgnC3qs?si=yBnHZHvKQvuqSDH5"
/>


<PracticeSection
title="《和平之友·体验气排球》"
date="2023年3月11日"
description="战友们身强力壮、意气风发、活力四射，首次体验就可以上场比赛！欢迎各社团组队参与“新西兰气排球协会总会（NZLVGA）的气排球体验计划，咱们一起在各社团普及气排球——这个开心健康的娱乐活动！每周六4-6.25pm，一树山高中体育馆见！微信联系：-mama-mia-）"
embedUri="3cTuy2vMVE0?si=QCnAJGz-yP-123pM"
/> 

<PracticeSection
title="NZLVGA《在姜虹教练指导下》"
date="2023年3月25日"
description="新西兰气排球协会总会在一树山中学(ONE TREE HILL COLLEGE）的一日训练. 
训练时间: 每周六下午4-6.25pm.
欢迎有基础或零基础的气排球爱好者加入！"
embedUri="4pdbWqeSzOs?si=TaSImkTORasg7aBu"
/>

<PracticeSection
title="《Make You Feel My Love》 🌺感受爱🌺"
date="2023年4月1日"
description="我们把第八周训练的镜头转向那些平日为大家顺利训练默默奉献的队伍里……
感谢八周来气排球爱好者们积极参与新西兰气排球协会总会(NZLVGA）的训练！
您们用爱心和信任来支持，我们用实力和感恩去回馈！ 每周六4-6.25pm，One Tree Hill College体育馆见"
embedUri="S2OS0o-DtMQ?si=dcUoZhakVehIpVda"
/>


<PracticeSection
title="《满血复活节》新西兰气排球协会总会----2023年复活节——我们一起度过！"
date="2023年4月8日"
description="原以为球友们会在假期外出，没想到昨天大家兴致勃勃相继聚到一起！真是意外的惊喜！
感谢姜教练、感谢Andy教练！2023年复活节——我们一起度过！欢迎加入新西兰气排球协会总会的训练大军，每周六下午4-6.25pm，One Tree Hill College体育馆见！
欢迎点赞和分享视频号，让更多的朋友开心来打气排球！"
embedUri="vOSk45yYzbk?si=d8486Xp3i9uJvAYf"
/>

<PracticeSection
title="《今天是个好日子》"
date="2023年4月15日"
description="昨晚偶然发现和平之友陈大哥表演的笛子独奏，演奏得惟妙惟肖！那是真功夫！回想今天他在气排球训练场上身轻如燕的身姿——这些和平之友60+的哥哥姐姐们真的值得学习！"
embedUri="t9FRbSBZZCE?si=sgPrzpOUjZ3cn6WK"
/>

<PracticeSection
title="新西兰气排球协会总会“融霞杯”积分赛冠军产生啦——白云队"
date="2023年4月29日"
description=""
embedUri="J1hZ590xllo?si=xUhqMDc8TAk-ou5q"
/>

<PracticeSection
title="《爱心在行动》"
date="2023年4月29日"
description="新西兰气排球协会总会“融霞杯”积分赛上，医疗救护组为赛场队员提供及时的救护，为赛事保驾护航！NZLVGA《爱心在行动》新西兰气排球协会总会“融霞杯”积分赛上，医疗救护组为赛场队员提供及时的救护，为赛事保驾护航！感恩Linda Lin的爱心奉献！"
embedUri="41-HLoLTEx0?si=kVBMkKP3LxQyTGqR"
/>

<PracticeSection
title="新西兰气排球协会总会“融霞杯”积分赛混合队Open组比赛集锦"
date="2023年4月29日"
description=""
embedUri="o2IkCjnQ0I0?si=nCsDYzG9jdCE9BU1"
/>

<PracticeSection
title="《传说中的快乐气排球》新西兰气排球协会总会融霞杯混合队45+组积分赛"
date="2023年5月6日"
description=""
embedUri="UW-EJI4d1Pg?si=9WImctRiqFqhW3Q3"
/>

<PracticeSection
title="《我们多么幸福》"
date="2023年5月13日"
description="姜教练刚刚从澳洲归来，就投入到密集的训练指导中。感谢姜教练！"
embedUri="h0i4NnsIqKo?si=WxAZDikmLJdpBFTR"
/>

<PracticeSection
title="感人的一幕《万里寻母记》"
date="2023年5月23日"
description="在福建福清举办的第四届全国老年人体育健身大会气排球交流活动 中，新西兰气排球协会总会的总裁判长兰姐在赛场上帮助会员找到了正在万里之外比赛的妈妈……"
embedUri="TlVXrOe71cY?si=kelwcG5-lfFuMi44"
/>

<PracticeSection
title="《闭幕式集锦》全国老年人气排球交流活动闭幕式"
date="2023年5月26日"
description="新西兰气排球协会总会第一届星光杯锦标赛总裁判长兰姐在福建福清现场报道！"
embedUri="21RkfoIRgrk?si=k-waZ1xBL4IuwBwx"
/>

<PracticeSection
title="《今天我嘚瑟》气排比赛小花絮"
date="2023年5月26日"
description="全国老年人气排球交流活动"
embedUri="_hnJJ83n-Ec?si=vPrFBhKseNUyuA58"
/>

<PracticeSection
title="《今天的相遇缘于昨日的相聚》----气排球的那些事儿"
date="2023年5月23日"
description="《寻找瑛姐的队友——今天的相遇源于昨日的相聚》几个月前经姜瑛姐的引荐，结识了辽宁鞍山气排球协会会长刘影大姐；得知她也在老年人健身大会气排球比赛现场，兰姐便一早从厦门出发，一路风尘仆仆到福建福清，才有了这次采访……感谢瑛姐、刘姐和兰姐！"
embedUri="/h2KYJanLyk8?si=Okvlf4F03_yXf9Zy"
/>

<PracticeSection
title="《私访长泰》----气排球的那些事儿"
date="2023年6月1日"
description="直播达人高山玉岩老师和兰姐参观福建长泰气排球训练馆。为我们拍下了珍贵的视频，一睹名将风采！"
embedUri="v-ZmJxm1w5I?si=1ZyWaBSHYRRjp1uw"
/>

<PracticeSection
title="《成长的足迹》记新西兰气排球协会总会一日训练 "
date="2023年6月3日"
description=""
embedUri="P074z-1k96Y?si=GQjaTRH7QdHbpHp0"
/>

<PracticeSection
title="《扣球训练》新西兰气排球协会总会一树山高中一日训练"
date="2023年6月10日"
description=""
embedUri="TUgapyzQjmY?si=BLHRem98TjkTnW-Y"
/>

<PracticeSection
title="《挑战最有高度的气排球》万方杯气排球邀请赛（第一场）花絮 "
date="2023年6月17日"
description=""
embedUri="hPxwFGF0AV4?si=avGly8mUpxct_8_p"
/>

<PracticeSection
title="《快乐大本营》快乐气排球，我们是一家——暨第一届万方杯气排球邀请赛 "
date="2023年6月24日"
description="主办：万方体育；
协办：新西兰气排球协会总会"
embedUri="EbaRLOxgZiI?si=Jh_tqhib82BT3zbC"
/>

<PracticeSection
title="新西兰万方杯气排球邀请赛男子组决赛（万方一队 vs 英雄联盟）"
date="2023年6月24日"
description="主办：新西兰万方体育
协办：新西兰气排球协会总会
🚩男子组排名：
🥇冠  军：万方一队
🥈亚  军：英雄联盟
🥉季  军：浩瀚苍穹
     第四名：万方二队
     第五名：同和一队
     第六名：浩瀚四海
     第七名：同和二队
     第八名：逸园队

🚩女子组排名：
🥇冠  军：万方同和
🥈亚  军：英雄联盟
🥉季  军：浩瀚闪电
     第四名：红土地
     第五名：浩瀚霹雳
     第六名：逸园队"
embedUri="wEGYwj7kHV4?si=7J-luPVvd7JAOfEn"
/>

<PracticeSection
title="《颁奖晚宴》新西兰首届万方杯气排球邀请赛"
date="2023年6月25日"
description="主办：万方体育
协办：新西兰气排球协会总会"
embedUri="f7pfzcpJanw?si=Ft0zJairXxSvnYbM"
/>

<PracticeSection
title="新西兰气排球协会总会训练新基地----北岸AUT基地介绍"
date="2023年7月5日"
description="气排协会的人员与日增加, 几尽周折终于在北岸找到了新的场地, 让我们先实地考察一下吧. "
embedUri="G_6b6IVj7m0?si=7eM-n4QJzUGawA6D"
/>

<PracticeSection
title="新西兰气排球协会总会——北岸AUT基地首次训练"
date="2023年7月7日"
description="新西兰气排球协会总会北岸AUT基地首次训练
🌺感谢新老朋友参加
🌺感谢湖南同乡会积极参与
🌺感谢姜虹总教练悉心指导
⭐️⭐️⭐️⭐️⭐️⭐️⭐️⭐️⭐️
         明天7月10日
          周一7-9pm
  北岸AUT基地不见不散！
⭐️⭐️⭐️⭐️⭐️⭐️⭐️⭐️⭐️"
embedUri="Suvsx3Fv_QM?si=_I9i5nyHi5tkxxkZ"
/>

<PracticeSection
title="新西兰气排球协会“康斯坦杯”积分赛: 黑土地vs英雄蓝队"
date="2023年8月26日"
description=""
embedUri="h-MC_GYJATU?si=KuHVlGSazPT4_1WJ"
/>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IndexVideo2Page;

